<template>
    <app-page-content>
        <app-title>Visitas</app-title>
        <v-expansion-panel>
            <v-expansion-panel-content>
            <div slot="header">Filtros</div>
            <v-card>
                <v-card-title class="headline">Filtros</v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-select
                                    :items="visitorsTypes"
                                    item-text="name"
                                    item-value="id"
                                    label="Tipo visitante"
                                    v-model="filters.visitorTypeId"
                                />  
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    label="Nombre visitante"
                                    v-model="filters.name"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <v-menu
                                    :close-on-content-click="false"
                                    v-model="menu"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                <v-text-field
                                    slot="activator"
                                    v-model="filters.date"
                                    label="Fecha ingreso"
                                    prepend-icon="event"
                                    readonly
                                    ></v-text-field>
                                    <v-date-picker v-model="filters.date" @input="menu = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs6>
                                <v-btn small color="primary" @click="searchVisits">Filtrar</v-btn>
                            </v-flex>
                            <v-flex xs6>
                                <v-btn small flat  @click="cancelFilter">Restablecer</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>                      
        <div v-if="visits.length"> 
            <v-list two-line>
                <template v-for="(visit, index) in visits">
                    <v-list-tile :key="visit.name">
                        <v-list-tile-avatar>
                            <img :src="visit.person.photo" alt="">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ visit.person.name }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ visit.created_at | datetime }}</v-list-tile-sub-title>
                            <v-list-tile-sub-title>{{ visit.visitor_type.name }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <!-- <v-list-title :key="visit.created_at">{{ visit.created_at | datetime }}</v-list-title> -->
                    <v-divider
                        :key="index"
                    ></v-divider>
                </template>
            </v-list>
            <div class="text-xs-center">
                <v-pagination
                    v-if="!!visits.length"
                    v-model="page"
                    :length="totalPages"
                ></v-pagination>
            </div> 
        </div>
        <v-alert v-else
            :value="!visits.length"
            type="info"
            >
            ¡Aún no has recibido ninguna visita!
        </v-alert>
    </app-page-content>
</template>
<script>
import visitsRepository from '../../repositories/visits.repository';
export default {
    data() {
        return {
            page: 1,
            data: null,
            filters: {},
            visitorsTypes: [],
            menu: ''
        };
    },
    watch: {
        page(val){
            this.loadVisits();
        }
    },
    computed: {
        visits() {
            if (!this.data) return [];
            return this.data.data;
        },
        totalPages(){
            if(!this.data) return 0;

            return Math.ceil(this.data.total / parseInt(this.data.per_page));
        }
    },
    methods: {
        loadVisits() {
            const vr = {...visitsRepository};
            vr.getPersonVisits(this.person.id, this.filters, this.page)
                .then(resp => {
                    this.data = resp.data;
                })
                .catch(error => {
                    if (error) {
                        console.log(error);
                    }
                });
        },
        searchVisits(){
            this.page = 1;
            this.loadVisits();
        },
        cancelFilter() {
            this.page = 1;
            Object.keys(this.filters).map(key => (this.filters[key] = ''));
            this.loadVisits();
        },
        loadVisitorTypes(){
            const vr = {...visitsRepository};
            vr.getVisitorTypes()
                .then(resp => {
                    this.visitorsTypes = resp.data;
                })
                .catch(error => {
                    // toastr.error('Error al cargar los tipos de visitantes', {dismissible: false});
                    console.log(error);
                });
        },
        initialize(){
            this.loadVisits();
            this.loadVisitorTypes();
        }
    },
    created() {
        this.initialize();
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/Visits/Visits.vue